import { FormControlLabel, Switch } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { USE_BETA_SCREENS } from '../../../../config/environment';
import { useBetaHook } from '../../hooks';

const BETA_PINK = '#f50057';

type Props = {
  onToggle: any;
};

const BetaSwitch = ({ onToggle }: Props) => {
  const { t } = useTranslation('common');
  const { isBetaEnabled, toggleBeta } = useBetaHook();

  const handleToggle = () => {
    toggleBeta();
    onToggle();
  };

  const isBetaScreensFeatureEnabled = USE_BETA_SCREENS?.toLowerCase() === 'true';

  return isBetaScreensFeatureEnabled ? (
    <React.Fragment>
      <FormControlLabel
        control={
          <Switch
            checked={isBetaEnabled}
            onChange={handleToggle}
            name="isBetaEnabled"
            sx={{
              '& .MuiSwitch-switchBase.Mui-checked': {
                color: BETA_PINK,
              },
              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                backgroundColor: BETA_PINK,
              },
            }}
          />
        }
        label={t('common:beta.enableBeta')}
      />
    </React.Fragment>
  ) : null;
};

export default BetaSwitch;
